import {CbJsonCareCalendar} from "@/api/pharma-cms-content-block/models";
import {NormalContentBlockModel} from "@/models/api/pharma-cms-content-block/NormalContentBlockModel";

export class CbJsonCareCalendarModel extends NormalContentBlockModel implements CbJsonCareCalendar {
    widget_code: string;

    constructor() {
        super();
        this.widget_code = '';
    }

    public static createWithDefaults(): CbJsonCareCalendarModel {
        return new this();
    }
}
